// src/Dashboard/pages/admin/Attendance/components/AttendanceDeletePanel.jsx
import React from "react";
import { FaExclamationTriangle, FaTrashAlt } from "react-icons/fa";

export default function AttendanceDeletePanel({
  loading,
  selectedGroup,
  form,
  setFormValue,
  onDelete,
  result,
}) {
  return (
    <section className="rounded-3xl border border-rose-200 bg-white p-5 shadow-sm shadow-rose-100/60 dark:border-rose-900/40 dark:bg-slate-900 dark:shadow-none">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
        <div>
          <p className="text-sm font-bold uppercase tracking-[0.24em] text-rose-500">
            Suppression des appels
          </p>

          <h2 className="mt-2 text-2xl font-bold text-slate-950 dark:text-white">
            Supprimer une période
          </h2>

          <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-500 dark:text-slate-400">
            Cette action supprimera uniquement les appels du groupe sélectionné :
            <span className="font-bold text-slate-900 dark:text-white">
              {" "}
              {selectedGroup?.nom || "Groupe"}
            </span>
            .
          </p>
        </div>

        <div className="rounded-3xl bg-rose-50 p-4 text-rose-700 ring-1 ring-rose-100 dark:bg-rose-900/20 dark:text-rose-200 dark:ring-rose-800/60">
          <div className="flex gap-3">
            <FaExclamationTriangle className="mt-0.5 shrink-0" />
            <p className="text-sm font-semibold">
              La suppression est définitive. Utilise cette action uniquement
              pour corriger une erreur de saisie ou nettoyer une période de test.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-6 grid gap-4 md:grid-cols-2">
        <label className="block">
          <span className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Date de début
          </span>

          <input
            type="date"
            value={form.startDate}
            onChange={(event) => setFormValue("startDate", event.target.value)}
            disabled={loading}
            className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-bold text-slate-700 outline-none transition focus:border-rose-400 focus:bg-white focus:ring-4 focus:ring-rose-100 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100"
          />
        </label>

        <label className="block">
          <span className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Date de fin
          </span>

          <input
            type="date"
            value={form.endDate}
            onChange={(event) => setFormValue("endDate", event.target.value)}
            disabled={loading}
            className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-bold text-slate-700 outline-none transition focus:border-rose-400 focus:bg-white focus:ring-4 focus:ring-rose-100 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100"
          />
        </label>
      </div>

      <div className="mt-6 flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={onDelete}
          disabled={loading}
          className="inline-flex items-center gap-2 rounded-2xl bg-rose-600 px-5 py-3 text-sm font-bold text-white shadow-lg shadow-rose-200/70 transition hover:-translate-y-0.5 hover:bg-rose-700 disabled:cursor-not-allowed disabled:opacity-60 dark:shadow-none"
        >
          <FaTrashAlt />
          Supprimer les appels de cette période
        </button>

        {result && (
          <span className="rounded-2xl bg-slate-100 px-4 py-3 text-sm font-bold text-slate-700 dark:bg-slate-950 dark:text-slate-200">
            {result.deleted || 0} appel(s) supprimé(s)
          </span>
        )}
      </div>
    </section>
  );
}